import React from "react";

import UserHeader from "./UserHeader";
import MyPageSetting from "./setting/MyPageSetting";

import { getName, getRoles } from "../../redux/reducers/user";
import { useAppSelector } from "../../redux/hooks";

type Props = {
  settings: Array<any>;
  logoutHandler: () => void;
};

const MyPageTop: React.FC<Props> = ({ settings, logoutHandler }) => {
  const name = useAppSelector(getName);
  const roles = useAppSelector(getRoles);

  return (
    <>
      {/* 夏季休暇、年末年始休暇などの HolidayAnnounce はここに追加する。コンポーネント有。 */}
      <UserHeader name={name} roles={roles} />
      <MyPageSetting
        settings={settings}
        logoutHandler={logoutHandler}
        showJikeiAdmin={
          roles?.includes("jikei_admin") || roles?.includes("jikei_manager")
            ? true
            : false
        }
        showAdmin={roles?.includes("admin") ? true : false}
      />
    </>
  );
};

export default MyPageTop;
